import { render, staticRenderFns } from "./ProfileMenuCompany.vue?vue&type=template&id=d9ea47b0&scoped=true&"
import script from "./ProfileMenuCompany.vue?vue&type=script&lang=js&"
export * from "./ProfileMenuCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ea47b0",
  null
  
)

export default component.exports